"use strict";

import React from "react";
import ReactDOM from "react-dom";
//import style from "./Popup.scss";

class Popup extends React.Component  {
    render() {
        return (
            <div className='popup-react' onClick={this.props.closePopup}>
                <div className='popup_inner'>
                    {this.props.text}
                    <div className="btn-tray">
                        <button onClick={this.props.closePopup} className="ui button primary btn btn-primary">close</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Popup;